<ng-template #confetti let-modal>
    <div class="confetti-wrapper"></div>
</ng-template>